import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Shell } from '@app/shell/shell.service';
import { PaymentDeclinedComponent } from './pages/checkout/steps/third-step/payment-declined/payment-declined.component';
import { DomainGuard } from './@shared/guards/domain.guard';

const routes: Routes = [
  Shell.childRoutes([
    {
      path: 'nosotros/por-que',
      data: { page: 'aboutUs' },
      loadChildren: () => import('./pages/about/about.module').then((m) => m.AboutModule),
    },
    {
      path: 'cotizar',
      data: { page: 'home' },
      canActivate: [DomainGuard],
      loadChildren: () => import('./pages/checkout/checkout.module').then((m) => m.CheckoutModule),
    },
    {
      path: 'pago',
      data: { page: 'paymentConfirmation' },
      loadChildren: () =>
        import('./pages/payment-confirmation/payment-confirmation.module').then((m) => m.PaymentConfirmationModule),
    },
    {
      path: 'confirmar-pago',
      data: { page: 'paymentConfirmation' },
      loadChildren: () =>
        import('./pages/process-payment-kushki/process-payment-kushki.module').then(
          (m) => m.ProcessPaymentKushkiModule
        ),
    },
    {
      path: 'consulta',
      data: { page: 'querySystem' },
      loadChildren: () => import('./pages/query-system/query-system.module').then((m) => m.QuerySystemModule),
    },
    {
      path: 'cotizador-de-proveedores',
      data: { page: 'supplierQuote' },
      loadChildren: () => import('./pages/supplier-quote/supplier-quote.module').then((m) => m.SupplierQuoteModule),
    },
    {
      path: 'proveedores',
      data: { page: 'sponsors' },
      canActivate: [DomainGuard],
      loadChildren: () => import('./pages/sponsors/sponsors.module').then((m) => m.SponsorsModule),
    },
    {
      path: 'planes',
      data: { page: 'coveragePlans' },
      loadChildren: () => import('./pages/plans/plans.module').then((m) => m.PlansModule),
    },
    {
      path: 'planes-b2b',
      data: { page: 'coveragePlansB2B' },
      loadChildren: () => import('./pages/plans-b2b/plans-b2b.module').then((m) => m.PlansB2bModule),
    },
    {
      path: 'preguntas-frecuentes',
      data: { page: 'faq' },
      canActivate: [DomainGuard],
      loadChildren: () => import('./pages/faq/faq.module').then((m) => m.FaqModule),
    },
    {
      path: 'preguntas-frecuentes-b2b',
      data: { page: 'faqB2b' },
      loadChildren: () => import('./pages/faq-b2b/faq-b2b.module').then((m) => m.FaqB2bModule),
    },
    {
      path: 'pago-rechazado/:hashCode',
      data: { page: 'paymentDeclined' },
      canActivate: [DomainGuard],
      component: PaymentDeclinedComponent,
    },
    {
      path: 'pagina-no-encontrada',
      data: { page: 'notFound' },
      loadChildren: () => import('./pages/not-found/not-found.module').then((m) => m.NotFoundModule),
    },
    {
      path: 'politicas-de-privacidad',
      data: { page: 'politicas' },
      loadChildren: () => import('./pages/policies/policies.module').then((m) => m.PoliciesModule),
    },
    {
      path: 'condiciones-de-uso',
      data: { page: 'condiciones' },
      loadChildren: () => import('./pages/conditions/conditions.module').then((m) => m.ConditionsModule),
    },
    {
      path: 'reclamos',
      data: { page: 'claims' },
      loadChildren: () => import('./pages/claims/claims.module').then((m) => m.ClaimsModule),
    },
    {
      path: 'contacto',
      data: { page: 'contacto' },
      loadChildren: () => import('./pages/contact/contact.module').then((m) => m.ContactModule),
    },
    {
      path: 'contacto-b2b',
      data: { page: 'contactoB2b' },
      loadChildren: () => import('./pages/contact-b2b/contact-b2b.module').then((m) => m.ContactB2bModule),
    },
    {
      path: 'ayuda-documento',
      data: { page: 'document-help' },
      canActivate: [DomainGuard],
      loadChildren: () => import('./pages/document-help/document-help.module').then((m) => m.DocumentHelpModule),
    },
  ]),
  {
    path: 'insurance-documents',
    data: { page: 'home' },
    loadChildren: () => import('./pages/documents/documents.module').then((m) => m.DocumentsModule),
  },
  {
    path: 'quotation-result',
    data: { page: 'querySystem' },
    loadChildren: () => import('./pages/quotation-result/quotation-result.module').then((m) => m.QuotationResultModule),
  },
  // Fallback when no prior route is matched
  { path: '**', redirectTo: '', pathMatch: 'full' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: 'reload',
      scrollPositionRestoration: 'top',
      anchorScrolling: 'enabled',
    }),
  ],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule {}
